import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, AppClientConfigurationService, WizardServiceLocator } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { LogContainer } from '@sdbn/tmc-common';

export class VisitorLeaveFailedController extends AbstractStepController {

    private cps: AppClientConfigurationService;
    private timer: any;

    constructor() {
        super();
        this.cps = WizardServiceLocator.injector.get(AppClientConfigurationService);
    }

    onContextChange(contextChange: ContextChange) { }

    onRegisterToDashboardContext() { }

    public handleFlow(): FlowStepHandleResult {

        const logContainer: LogContainer = this.dashboardContext.context.get('logContainer');
        logContainer.addLog('visitor leave failed started');

        this.timer = setTimeout(() => {
            this.finish();
        }, parseInt(this.cps.getPropertyValue('tmc-yard.terminal.summary-timer', '60')) * 1000);

        const result = new FlowStepHandleResult();
        result.type = HandleResultType.DASHBOARD;
        return result;
    }

    getControls(): StepControl[] {
        const controls = new Array<StepControl>();

        const spacer = new StepControl();
        spacer.type = StepControlType.SPACER_GROW;
        controls.push(spacer);

        const finishControl = new StepControl();
        finishControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.visitor-leave-failed.button.finish';
        finishControl.type = StepControlType.BUTTON;
        finishControl.controlAction = this.finish.bind(this);
        controls.push(finishControl);

        return controls;
    }

    private finish() {
        clearTimeout(this.timer);
        this.wizardComponent.restartWizard();
    }
}
